import React from 'react';
// Customizable Area Start
import { Theme, createStyles, withStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  TextField,
  Button,
  TextareaAutosize,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
} from "@material-ui/core";
import clsx from "clsx"
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import UserProfileController, { Props } from "./UserProfileController.web";
import { next, trueIcon, profileHover, evrybrand } from "./assets";
import NavigationMenuEu from "../../../components/src/NavigationMenuEU.web";
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { CloseRounded } from '@material-ui/icons';
import ImageUploadSetWeb from '../../../components/src/ImageUploadSet.web';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import CustomButton from '../../../components/src/CustomButton.web';
import CustomDialog from '../../../components/src/CustomDialog.web';
import MobileNavEndUser from '../../dashboard/src/MobileNavEndUser.web';
export const configJSON = require('./config.js');

SwiperCore.use([Navigation]);

const styles = (theme: Theme) =>
  createStyles({
    headerprofile: {
      backgroundColor: "#FFC629",
      height: "217px",
      border: "1px solid #FFC629 ",
      borderRadius: "0px 0px 48px 0px",
      position: "relative",
    },
    maincontainer: {
      margin: "50px 25px",
      paddingBottom: "30px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      overflow: "hidden",
      [theme.breakpoints.down(650)]: {
        margin: "50px 0"
      },
    },
    overlay: {
      cursor: "pointer",
      position: "absolute",
      top: "139px",
      left: "39px",
      backgroundColor: "rgba(0, 0, 0, 0.60)",
      border: "2px solid #FFF",
      width: "156px",
      height: "156px",
      borderRadius: "50%",
      overflow: "hidden",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.3s ease',
    },
    imgprofileHover: {
      width: "100%",
    },
    profileCameraBtn: {
      position: "absolute",
      top: "264px",
      left: "150px",
      background: "#fff",
      border: "2px solid #fff",
      borderRadius: "50%",
      padding: "2px",
      zIndex: 1,
    },
    hoverImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    imgprofile: {
      cursor: "pointer",
      position: "absolute",
      top: "139px",
      left: "39px",
      backgroundColor: "#FFC629",
      border: "4px solid #F0E5FF",
      width: "156px",
      height: "156px",
      borderRadius: "50%",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      objectFit: "cover"
    },
    formWrapper: {
      margin: "120px auto 0px",
      padding: "20px",
      maxWidth: "900px",
      [theme.breakpoints.down(950)]: {
        maxWidth: "unset",
        padding: "20px 12px",
      },
    },
    labelField: {
      letterSpacing: "0px",
      textAlign: "left",
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: "30px",
      fontFamily: "Inter, 'sans-serif'",
      [theme.breakpoints.down(768)]: {
        fontSize: "16px"
      },
    },
    textField: {
      "& input": {
        borderRadius: "8px",
        color: "#0F172A",
        padding: "16px 15px",
        fontFamily: "Inter, 'sans-serif'"
      }
    },
    maincontainerProfile: {
      maxWidth: "1087px",
      margin: "0 auto",
      [theme.breakpoints.down(960)]: {
        maxWidth: "unset",
        width: "100vw",
        paddingBottom: "20px"
      },
    },
    nextHomePage: {
      backgroundColor: "#FFC629",
      textTransform: "capitalize" as "capitalize",
      padding: "9px 16px",
      width: "252px",
      borderRadius: "8px",
      gap: "8px",
      boxShadow: "none",
      alignSelf: "end",
      "& span": {
        fontSize: "16px",
        fontWeight: 700,
        fontFamily: "Inter, 'sans-serif'"
      },
      "&:hover": {
        backgroundColor: "#FFC629",
        boxShadow: "none",
      }
    },
    nextHomePage2: {
      backgroundColor: "#FFC629",
      textTransform: "capitalize" as "capitalize",
      height: "44px",
      gap: "8px",
      padding: "10px 16px 10px 16px",
      width: "188",
      borderRadius: "8px",
      boxShadow: "none",
      fontFamily: "Inter, 'sans-serif'",
      "& span": {
        fontWeight: 700,
        fontSize: "16px",
      },
      "&:hover": {
        boxShadow: "none",
        backgroundColor: "#FFC629",
      }
    },
    imageEditDialog:{
      [theme.breakpoints.down(650)]: {
        "& .MuiDialog-paperFullWidth":{
          width: "100%",
        },
        "& .MuiDialog-paper":{
          margin: "0px"
        }

      },
    },
    profileDialogTitle: {
      padding: "7px 7px 0px",
      "& > h2": {
       textAlign: "end"
      }
    },
    profileDialogContent: {
      padding: "0px 24px 24px !important",
      [theme.breakpoints.down(650)]: {
        padding: "0px 0px 24px !important"
      },
    },
    promptDialogTitle: {
      padding: "10px 10px 0px",
      "& > h2": {
        textAlign: "end"
       }
    },
    promptDialogContent: {
      padding: "24px",
      "& > div:first-child": {
        backgroundColor: "#FFC629",
        borderRadius: "10px",
        padding: "15px",
      },
      "& .prompt-question": {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: "Inter, 'sans-serif'",
        lineHeight: "24px"
      },
      "& textarea": {
        width: "100%",
        border: "none",
        fontSize: "25px",
        fontWeight: 700,
        fontFamily: "Inter, 'sans-serif'",
        lineHeight: "30px",
        backgroundColor: "#FFC629",
        resize: "none",
        marginTop: "10px",
        outline: "none",
        [theme.breakpoints.down(768)]: {
          fontSize: "16px"
        },
        "&::placeholder": {
          opacity: 1,
          color: "#000"
        }
      }
    },
    errorText: {
      fontSize: "13px",
      fontFamily: "Inter, 'sans-serif'",
      color: "#f44336",
      fontWeight: 500
    },
    promptDialogActions: {
      padding: "0px 24px 24px"
    },
    profileData: {
      lineHeight: "30px",
      fontSize: "25px",
      fontWeight: 700,
      letterSpacing: "0px",
      fontFamily: "Inter, 'sans-serif'",
      marginTop: "50px",
      [theme.breakpoints.down(768)]: {
        fontSize: "20px"
      },
    },
    headlineWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down(650)]: {
        marginTop: "6px",
        gap: "12px",
        alignItems: "start",
        flexDirection: 'column'
      },
    },
    headline: {
      fontSize: "20px",
      lineHeight: "30px",
      letterSpacing: "0px",
      textAlign: "left",
      fontWeight: 700,
      marginTop: "40px",
      fontFamily: "Inter, 'sans-serif'",
      [theme.breakpoints.down(768)]: {
        fontSize: "20px"
      },
    },
    headlineInfo: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "left",
      fontFamily: "Inter, 'sans-serif'"
    },
    basicInfo: {
      fontWeight: 400,
      letterSpacing: "0px",
      fontSize: "14px",
      textAlign: "left",
      lineHeight: "24px",
      fontFamily: "Inter, 'sans-serif'"
    },
    textareaAdd: {
      width: "100%",
      marginTop: "30px",
      padding: "10px",
      border: "1px solid #CBD5E1",
      borderRadius: "8px",
      fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    fontFamily: "Inter",
    "&:focus": {
      outline: "none",
      border: "2px solid #FFC629",
    },
    },
    card: {
      borderRadius: '10px',
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      fontSize: "14px",
      fontWeight: 700,
      backgroundColor: '#000',
      alignItems: 'center',
      height: '115px',
      textAlign: 'center',
      boxShadow: "none",
      fontFamily: "Inter, 'sans-serif'",
      position: "relative",
      "& .MuiCardContent-root": {
        padding: "20px"
      }
    },
    selectedCard: {
      backgroundColor: "#FFC629",
      "& div": {
        color: "#000"
      }
    },
    promptRemove: {
      color: "#000",
      position: "absolute",
      top: "5px",
      right: "5px",
      zIndex: 1,
      border: "1px solid #000",
      padding: "1px",
      "& svg": {
        fontSize: "15px"
      }
    },
    text: {
      fontSize: '14px',
      fontWeight: 700
    },
    everybrand: {
      position: "absolute",
      bottom: "29px",
      right: "3px",
      "@media screen and (max-width: 480px)": {
        top: "20px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
      }
    },
    personalitiesWrapper: {
      position: "relative",
      marginTop: "35px",
      padding: "0px 40px",
      "& .swiper-wrapper": {
        height: "auto"
      },
      [theme.breakpoints.down(950)]: {
        // display: "none"
      },
    },
    hideVisibility: {
      opacity: 0.3
    },
    nextIcon: {
      cursor: "pointer",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      right: "-5px",
      [theme.breakpoints.down(650)]: {
        position: "static",
        transform: "none",
        marginLeft: "10px",
        marginTop: "10px",
      },
    },
    previousIcon: {
      cursor: "pointer",
      transform: "translateY(-50%) rotate(180deg)",
      position: "absolute",
      top: "50%",
      left: "-5px",
      [theme.breakpoints.down(650)]: {
        position: "static",
        transform: "rotate(180deg)",
        marginRight: "10px",
        marginTop: "10px",
      },
    },
    customRipple: { backgroundColor: 'rgb(255, 198, 41)'},
    cancelButton: {
      width: "87px",
      height: "44px",
      padding: "10px 16px 10px 16px",
      borderRadius: "8px",
      gap: "8px",
      textTransform: "capitalize" as "capitalize",
      fontSize: "16px",
      fontWeight: 700,
      backgroundColor: "#000",
      color: "#fff",
      marginRight: "20px",
      boxShadow: "none",
      fontFamily: "Inter, 'sans-serif'",
      "&:hover": {
        boxShadow: "none",
        backgroundColor: "#000",
      }
    },
    buttongroup: {
      float: "right"
    },
    profileLoader:{
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      left: "95px",
      top: "200px",
      position: "absolute",
      zIndex: 1 
    },

    customPlaceholderForTextaea:{

    },
    customPlaceholder:{
      "&::placeholder":{
      color:"#0F172A",
      opacity:1
      }
    },
    desktopArrows: {
      [theme.breakpoints.down(650)]: {
        display: "none",
      },
    },
    mobileArrows: {
      display: "none",
      justifyContent: "center",
      gap: "15px",
      marginBottom: "10px",
      [theme.breakpoints.down(650)]: {
        display: "flex",
      },
    }
  });

class UserProfile extends UserProfileController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { classes, navigation } = this.props;
    const {
      personalities,
      name,
      businessName,
      email,
      profileImage,
      isLoading,
      currentcity,
      currentstate,
      aboutprofile,
      hoverImg,
      isProfileLoading,
      emailError,
      isProfileDialog,
      alertType,
      selectedImageToSet,
      swiperInstance,
      isPromptDialog,
      promptQuestion,
      promptAnswer,
      promptAnswerError,
      isEndUser
    } = this.state

    const chunkSize = 6;
    const slides = [];
    for (let i = 0; i < personalities.length; i += chunkSize) {
      slides.push(personalities.slice(i, i + chunkSize));
    }
    const isFirstSlide = swiperInstance ? swiperInstance.activeIndex === 0 : true;
    const isLastSlide = swiperInstance ? swiperInstance.activeIndex === slides.length - 1 : true;

    return (
      <>
        <Snackbar
          open={this.state.isShowAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            data-test-id="alert-message"
            severity={alertType}
          >
            {this.state.showSucess}

          </MuiAlert>
        </Snackbar>
        {this.state.isEndUser && <NavigationMenuEu/>}
        {isLoading ? <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }} ><CircularProgress /></Box > :
          <>
            <Box className={classes.maincontainerProfile} >
              <Box className={classes.maincontainer}>
                <Box className={classes.headerprofile}>
                  <div
                    onMouseEnter={() => this.showHoverImg()}
                    onMouseLeave={() => this.hideHoverImg()}
                    data-test-id="mouseEvents"
                    style={{position:"relative"}}
                  >
                    {isProfileLoading
                             ? <Box  className={classes.profileLoader}><CircularProgress/></Box > :
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={this.handleFileChange}
                        id="imageInput"
                        data-test-id="imageInput"
                        name="photo"
                      />
                    }

                    <label htmlFor="imageInput">
                      <img
                        src={this.state.selectedProfileImage || (profileImage.length > 0 ? profileImage : "")}
                        alt=""
                        className={classes.imgprofile}
                      />

                    <div className={classes.profileCameraBtn}><CameraAltIcon/></div>

                      {hoverImg &&
                        <div className={classes.overlay}>
                          <img
                            alt="Hover Image"
                            src={profileHover}
                            className={classes.imgprofileHover}
                          />
                        </div>
                      }
                    </label>
                  </div>
                  <div className={classes.everybrand}>
                    <img src={evrybrand} alt="everybrand" width="75%" />
                  </div>
                </Box>
                <Box className={classes.formWrapper}>
                  <Typography variant="h6" gutterBottom className={classes.labelField} >
                    {isEndUser ? "Name" : "Business Name"}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={isEndUser ? "Diana Turner" : "Enter your business name"}
                    variant="outlined"
                    size="small"
                    name={isEndUser ? "name" : "businessName"}
                    className={classes.textField}
                    onChange={(e) => this.handleFieldChange(e)}
                    value={isEndUser ? name : businessName}
                    data-test-id="name"
                  />

                  <Typography variant="h6" gutterBottom className={classes.labelField} >
                    {"Name"}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={"Diana Turner"}
                    variant="outlined"
                    size="small"
                    name={"name"}
                    className={classes.textField}
                    onChange={(e) => this.handleFieldChange(e)}
                    value={name}
                    data-test-id="name"
                  />
                  <Box mt={5} marginTop={5}>
                    <Typography variant="h6" gutterBottom className={classes.labelField}>
                      Email
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Dturner12@mail.com"
                      variant="outlined"
                      name="email"
                      className={classes.textField}
                      onChange={(e) => this.handleFieldChange(e)}
                      value={email}
                      data-test-id="email"
                      error={Boolean(emailError)}
                      helperText={emailError}
                      disabled={this.state.isEndUser ? false : true}
                    />
                  </Box>

                  <Box>
                    <Typography variant="h4" gutterBottom className={classes.profileData}>
                      Let's make your profile a little more you.
                    </Typography>
                    <Typography variant="h4" className={classes.headline}>
                      Headline
                    </Typography>
                    <Box className={classes.headlineWrapper}>
                      <Typography variant="subtitle1" className={classes.headlineInfo}>
                        Make your personality stand out from the crowd.
                      </Typography>
                    </Box>
                    <TextareaAutosize minRows={7} 
                      className={classes.textareaAdd} 
                      name="aboutprofile" 
                      data-test-id="aboutprofile" 
                      value={aboutprofile} 
                      onChange={(e) => this.handleFieldChange(e)} 
                      placeholder={configJSON.placeHolderHeadlineText} 
                    />
                    <Box marginTop={5}>
                      <Typography variant="h6" gutterBottom className={classes.labelField} >
                        Current City
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Add City"
                        variant="outlined"
                        size="small"
                        name="currentcity"
                        className={classes.textField}
                        onChange={(e) => this.handleFieldChange(e)}
                        value={currentcity}
                        data-test-id="currentcity"
                      />
                    </Box>
                    <Box marginTop={5}>
                      <Typography variant="h6" className={classes.labelField} gutterBottom>
                        Current State
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Add state abreviations"
                        variant="outlined"
                        name="currentstate"
                        className={classes.textField}
                        onChange={(e) => this.handleFieldChange(e)}
                        value={currentstate}
                        size="small"
                        data-test-id="currentstate"
                      />
                    </Box>
                  </Box>

                  <Box>
                    <Typography data-test-id="personality-prompt-heading" variant="h4" gutterBottom className={classes.profileData}>
                      Pick a Personality Prompt
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom className={classes.basicInfo}>
                      It´s the perfect opportunity to showcase your sense of humor, hobbies, interests, and your overall personality.
                    </Typography>
                  </Box>
                  {/* <Box className={classes.personalitiesWrapper}>
                    <img
                      id="previous-button"
                      src={next}
                      alt="next"
                      className={clsx(classes.previousIcon, {
                        [classes.hideVisibility]: isFirstSlide
                      })}
                    />
                    <Swiper
                      slidesPerView={1}
                      navigation={{
                        prevEl: "#previous-button",
                        nextEl: "#next-button",
                      }}
                      onSwiper={(swiper) => this.setState({ swiperInstance: swiper })}
                      onSlideChange={this.handleSlideChange}
                    >
                      {slides.map((slidePrompts) => (
                        <SwiperSlide key={slidePrompts}>
                          {this.renderPrompts(slidePrompts)}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <img
                      id="next-button"
                      src={next}
                      alt="next"
                      className={clsx(classes.nextIcon, {
                        [classes.hideVisibility]: isLastSlide
                      })}
                    />
                  </Box> */}
<Box className={classes.personalitiesWrapper}>
  {/* Desktop navigation arrows (left/right) */}
  <Box className={classes.desktopArrows}>
    <img
      id="previous-button"
      src={next}
      alt="previous"
      className={clsx(classes.previousIcon, {
        [classes.hideVisibility]: isFirstSlide,
      })}
    />
    <img
      id="next-button"
      src={next}
      alt="next"
      className={clsx(classes.nextIcon, {
        [classes.hideVisibility]: isLastSlide,
      })}
    />
  </Box>

  {/* Mobile navigation arrows (above swiper) */}
  <Box className={classes.mobileArrows}>
    <img
      id="previous-button-mobile"
      src={next}
      alt="previous"
      className={classes.previousIcon}
      style={{ transform: "rotate(180deg)" }}
    />
    <img
      id="next-button-mobile"
      src={next}
      alt="next"
      className={classes.nextIcon}
    />
  </Box>

  <Swiper
    slidesPerView={1}
    navigation={{
      prevEl:
        window.innerWidth <= 650
          ? "#previous-button-mobile"
          : "#previous-button",
      nextEl:
        window.innerWidth <= 650 ? "#next-button-mobile" : "#next-button",
    }}
    onSwiper={(swiper) => this.setState({ swiperInstance: swiper })}
    onSlideChange={this.handleSlideChange}
  >
    {slides.map((slidePrompts) => (
      <SwiperSlide key={slidePrompts}>
        {this.renderPrompts(slidePrompts)}
      </SwiperSlide>
    ))}
  </Swiper>
</Box>


                  <Box marginTop={5} className={classes.buttongroup} >
                    <Button
                      variant="contained"
                      className={classes.cancelButton}
                      data-test-id="cancelbutton"
                      onClick={this.handleCancleChanges}
                      TouchRippleProps={{
                        classes: {
                          rippleVisible: classes.customRipple 
                        }
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      data-test-id="nextHomePage2"
                      className={classes.nextHomePage2}
                      startIcon={<img src={trueIcon} alt="img" />}
                      onClick={this.handleSaveChanges}
                    >
                      Save changes
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        }
        <Dialog
          fullWidth
          maxWidth="sm"
          open={isProfileDialog}
          onClose={this.closeProfileImageSetDialog}
          className={classes.imageEditDialog}
        >
          <DialogTitle className={classes.profileDialogTitle}>
            <IconButton size="small" onClick={this.closeProfileImageSetDialog}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.profileDialogContent}>
            <ImageUploadSetWeb
              file={selectedImageToSet}
              setPicture={this.handleProfileSetButtonClick}
              closeModal={this.closeProfileImageSetDialog}
            />
          </DialogContent>
        </Dialog>
        <CustomDialog
          fullWidth={true}
          maxWidth="sm"
          open={isPromptDialog}
          onClose={this.closePromptDialog}
        >
          <DialogTitle className={classes.promptDialogTitle}>
            <IconButton size="small" onClick={this.closePromptDialog}>
              <CloseRounded />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.promptDialogContent}>
            <Box>
              <Typography className="prompt-question">{promptQuestion}</Typography>
              <TextareaAutosize
                autoFocus
                minRows={6}
                maxRows={6}
                data-test-id="prompt-answer-field"
                placeholder="Tell Us.."
                value={promptAnswer}
                onChange={this.handlePromptAnswerChange}
              />
            </Box>
            <Box hidden={!promptAnswerError}>
              <Typography data-test-id="prompt-answer-error" className={classes.errorText}>
                Please enter your answer
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions className={classes.promptDialogActions}>
            <CustomButton data-test-id="add-to-profile" btnType='secondary' onClick={this.handleAddPrompt}>
              Add to Profile
            </CustomButton>
          </DialogActions>
        </CustomDialog>
        <MobileNavEndUser navigation={navigation} />
      </>
    );
  }
}

export { UserProfile };
export default withStyles(styles)(UserProfile);
// Customizable Area End
